import { lazy } from 'react';

const lazyImport = (filename) =>
  lazy(() =>
    // FAKE DELAY
    new Promise((resolve) => {
      setTimeout(resolve, 200);
    }).then(() => import(`${filename}`))
  );

export default lazyImport;
